import React from 'react';

import { MaskitoOptions } from '@maskito/core';
import { useMaskito } from '@maskito/react';
import { TextField } from '@material-ui/core';

import { cnpjMask, cpfMask } from 'utils/maskito-masks';

type DocumentTextFieldProps = React.ComponentProps<typeof TextField> & {
  documentType: 'CPF' | 'CNPJ';
};

export default function DocumentTextField({
  documentType,
  ...props
}: DocumentTextFieldProps) {
  const inputRef = useMaskito({
    options: (documentType === 'CPF' ? cpfMask : cnpjMask) as MaskitoOptions,
  });

  return <TextField type="text" {...props} ref={inputRef} />;
}
